/* =====================================================================
   HEADER + FOOTER TEXT AND LINKS — English (en) and Korean (ko).
   `to` = page route.  `hash` = section id on that page (optional).
   The contact e-mail address is set once in src/services/inquiry.js.
   ===================================================================== */

export const site = {
  en: {
    homeLabel: "K SMART SYSTEMS home",
    skip: "Skip to content",
    platform: "Platform",
    platformMenu: [
      { title: "Platform overview", text: "KS-101 hardware, K SMART V2 software and the four modules", to: "/platform" },
      { title: "How it works", text: "From machine signal to line decision", to: "/", hash: "flow" },
      { title: "Digital twin demonstration", text: "Find a bottleneck and test a balancing move", to: "/demo", hash: "twin" },
      { title: "Role views demonstration", text: "Operator, manager and brand screens", to: "/demo", hash: "platform-demo" },
    ],
    mega: {
      col1: "Platform",
      col2: "Try it",
      feature: { media: "menu.feature", title: "Digital twin challenge", text: "Find the bottleneck on a sample line and move an operator", to: "/demo#twin" },
    },
    nav: [
      { label: "Demo", to: "/demo" },
      { label: "Projects", to: "/projects" },
      { label: "Company", to: "/company" },
    ],
    contact: "Contact",
    language: "Language",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    menu: "Menu",
    footer: {
      description: "K SMART SYSTEMS builds hardware and software that turn sewing machine signals into production data for garment factories.",
      cols: [
        { title: "Platform", links: [
          { label: "Platform overview", to: "/platform" },
          { label: "How it works", to: "/", hash: "flow" },
          { label: "Digital twin demo", to: "/demo", hash: "twin" },
          { label: "Role views demo", to: "/demo", hash: "platform-demo" },
        ] },
        { title: "Company", links: [
          { label: "About KSS", to: "/company" },
          { label: "Projects and pilots", to: "/projects" },
          { label: "Partnership model", to: "/projects", hash: "partners" },
          { label: "Brand film", to: "/company", hash: "film" },
        ] },
      ],
      contactTitle: "Contact",
      contactText: "Questions about a line, a pilot or a partnership.",
      inquiry: "Send an inquiry",
      privacy: "Privacy notice",
      rights: "© 2026 K Smart Systems Co., Ltd.",
      domain: "ksmartsystems.com",
    },
  },
  ko: {
    homeLabel: "K SMART SYSTEMS 홈",
    skip: "본문으로 건너뛰기",
    platform: "플랫폼",
    platformMenu: [
      { title: "플랫폼 개요", text: "KS-101 하드웨어, K SMART V2 소프트웨어, 네 가지 모듈", to: "/platform" },
      { title: "작동 방식", text: "재봉기 신호에서 라인의 결정까지", to: "/", hash: "flow" },
      { title: "디지털 트윈 데모", text: "병목을 찾고 밸런싱을 시험해 보기", to: "/demo", hash: "twin" },
      { title: "역할별 화면 데모", text: "작업자, 관리자, 브랜드 화면", to: "/demo", hash: "platform-demo" },
    ],
    mega: {
      col1: "플랫폼",
      col2: "체험하기",
      feature: { media: "menu.feature", title: "디지털 트윈 도전 과제", text: "샘플 라인에서 병목을 찾고 작업자를 옮겨 보세요", to: "/demo#twin" },
    },
    nav: [
      { label: "데모", to: "/demo" },
      { label: "프로젝트", to: "/projects" },
      { label: "회사 소개", to: "/company" },
    ],
    contact: "문의하기",
    language: "언어",
    openMenu: "메뉴 열기",
    closeMenu: "메뉴 닫기",
    menu: "메뉴",
    footer: {
      description: "K SMART SYSTEMS는 재봉기 신호를 봉제 공장의 생산 데이터로 바꾸는 하드웨어와 소프트웨어를 만듭니다.",
      cols: [
        { title: "플랫폼", links: [
          { label: "플랫폼 개요", to: "/platform" },
          { label: "작동 방식", to: "/", hash: "flow" },
          { label: "디지털 트윈 데모", to: "/demo", hash: "twin" },
          { label: "역할별 화면 데모", to: "/demo", hash: "platform-demo" },
        ] },
        { title: "회사", links: [
          { label: "회사 소개", to: "/company" },
          { label: "프로젝트·파일럿", to: "/projects" },
          { label: "파트너십 모델", to: "/projects", hash: "partners" },
          { label: "브랜드 필름", to: "/company", hash: "film" },
        ] },
      ],
      contactTitle: "문의",
      contactText: "라인, 파일럿, 파트너십에 관한 문의를 받습니다.",
      inquiry: "문의 보내기",
      privacy: "개인정보 처리방침",
      rights: "© 2026 K Smart Systems Co., Ltd.",
      domain: "ksmartsystems.com",
    },
  },
};
